
import React, { useState, useRef } from "react";
import { FaMapMarkerAlt, FaMapMarked } from "react-icons/fa";

const MapPin = ({ top, right, name, description, maps }) => {
  const [isOpen, setIsOpen] = useState(false);
  const popoverRef = useRef(null);

  const togglePopover = () => setIsOpen((prev) => !prev);

  const handleClickOutside = (event) => {
    if (popoverRef.current && !popoverRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className="absolute"
      style={{ top: top, right: right }}
    >
      <button
        onClick={togglePopover}
        className="w-8 h-8  text-white hover:text-blue-500"
      >
        <FaMapMarkerAlt className="w-8 h-8" />
      </button>
      {/* Popover Content */}
      {isOpen && (
        <div
          ref={popoverRef}
          className="absolute z-50 bottom-full left-1/2 transform -translate-x-1/2 mb-5 w-48 bg-white dark:bg-gray-600 rounded-lg"
        >
          <div className="flex flex-col p-4 gap-3">
            <div className="flex flex-row justify-between items-center">
              <h4 className="text-lg font-semibold">{name}</h4>
              <a href={maps} target="_blank">
                <FaMapMarked className="w-6 h-6 text-white hover:text-blue-500" />
              </a>
            </div>
            <div className="flex flex-col gap-1 text-sm">
              {description.map((line) => (
                <p>
                  {line}
                </p>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MapPin;